module.exports = __webpack_public_path__ + "img/fujian1.083cd8b7.png";